import { BaseApi } from '../../../api/apiBase';
import type { Survey, SurveyPageResponse, SurveyResponses } from '../../types/surveys/publicSurvey.types';

class SurveysApi extends BaseApi {
  constructor() {
    super('/api/portal');
  }

  async getSurvey(eventSlug: string, surveySlug: string): Promise<Survey> {
    return this.get<Survey>(`/events/${eventSlug}/surveys/${surveySlug}`);
  }

  async getSurveyPage(eventSlug: string, surveySlug: string, pageIndex: number): Promise<SurveyPageResponse> {
    return this.get<SurveyPageResponse>(`/events/${eventSlug}/surveys/${surveySlug}/survey_pages/${pageIndex}`);
  }

  async submitSurvey(eventSlug: string, surveySlug: string, responses: SurveyResponses): Promise<any> {
    return this.post(`/events/${eventSlug}/surveys/${surveySlug}/submissions`, responses);
  }
}

export const surveysApi = new SurveysApi();